// src/hooks/useAuthStatus.js
import { useEffect, useState } from "react";
import { fetchUserAttributes } from "@aws-amplify/auth";
import { resolveSessionAcrossPools } from "../auth/resolveSession";

export function useAuthStatus() {
  const [checked, setChecked] = useState(false);
  const [user, setUser] = useState(null);
  const [attrs, setAttrs] = useState(null);

  useEffect(() => {
    let mounted = true;

    // (Optional) quick hint from cache to avoid flicker
    const cached = sessionStorage.getItem("bookish_user_attrs");
    if (cached) {
      try { setAttrs(JSON.parse(cached)); } catch {}
    }

    (async () => {
      try {
        const session = await resolveSessionAcrossPools({ read: fetchUserAttributes });
        if (!session) throw new Error("No active session");

        const u = session.user;
        const a = session.data; // includes custom:membershipactive, sub, etc.
        if (!mounted) return;
        setUser(u);
        setAttrs(a);
        sessionStorage.setItem("bookish_user_attrs", JSON.stringify(a));
      } catch {
        if (!mounted) return;
        setUser(null);
      } finally {
        if (mounted) setChecked(true);
      }
    })();

    return () => { mounted = false; };
  }, []);

  return { checked, user, attrs };
}
